import React from 'react';
import useHeaderStyles from './header.styles';
import DashboardTabs from './DashboardTabs';
import Profile from './Profile';
import Hamburger from './Hamburger';
import { DART_LOGO } from '../../config/constant';

const Header: React.FC = () => {
  const classes = useHeaderStyles();

  return (
    <header className={classes.header}>
      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        <img src={DART_LOGO} alt="DART Logo" style={{ height: 28, marginRight: 20 }} />
        <DashboardTabs />
      </div>
      <div style={{ flex: 1, justifyContent: 'flex-end', display: 'flex' }}>
        <Profile />
      </div>
      <div>
        <Hamburger />
      </div>
    </header>
  );
};

export default Header;